export default __webpack_public_path__ + "static/admission-banner-a53fd9d28f723ea6387efa6288b5d7ba.jpg";